import { h1, paragraph } from "@/styles/typography";
import { GatsbyImage } from "gatsby-plugin-image";
import styled from "styled-components";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  width: 100%;
  margin-top: 62px;
  margin-bottom: 64px;
  @media screen and (max-width: 992px) {
    margin-top: 0px;
    margin-bottom: 20px;
  }
`;

const TextContainer = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 50px;

  @media screen and (max-width: 992px) {
    flex-direction: column;
    gap: 14px;
  }
`;

const TitleWrapper = styled(h1)`
  display: flex;
  flex-direction: column;
  width: 100%;

  @media screen and (${({ theme }) => theme.breakpoints.sm}) {
    margin-top: 0;
  }
`;

const Title1 = styled.span`
  color: ${({ theme }) => theme.colors.tango};
`;
const Title2 = styled.span`
  color: ${({ theme }) => theme.colors.softBlack};
`;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  @media screen and (max-width: 992px) {
    width: 100%;
  }
`;

const Subtitle = styled(paragraph)`
  font-weight: 400;
`;

const TextEllipse = styled.div<{ isTextLimited: boolean }>`
  overflow: ${({ isTextLimited }) => (isTextLimited ? "hidden" : "visible")};
  height: ${({ isTextLimited }) => (isTextLimited ? "150px" : "100%")};
  margin-bottom: 10px;

  @media screen and (${({ theme }) => theme.breakpoints.sm}) {
    height: ${({ isTextLimited }) => (isTextLimited ? "100px" : "100%")};
  }
`;

const Text = styled(paragraph)<{ isTextLimited: boolean }>`
  color: ${({ theme }) => theme.colors.softBlack};
  display: inline;
`;

const ShowMore = styled(paragraph)`
  color: ${({ theme }) => theme.colors.tango};
  cursor: pointer;
`;

const S = {
  Container,
  TextContainer,
  TitleWrapper,
  Title1,
  Title2,
  TextWrapper,
  Subtitle,
  TextEllipse,
  Text,
  ShowMore,
};

export default S;
